<template>
  <div>
    <loading v-show="load" :fullscrean="true" text="Carregando os dados"/>
    <div v-show="!load">
      <div v-if="!component">
        <bottom-bar ref="bottomBar" :hide-botton="qtdSacola"/>
        <div class="fixed-bottom bg-white fixed-container" :class="{'d-md-none': origin !== '8'}" v-if="qtdSacola">
          <div class="bg-white border-top">
            <div class="p-3">
              <a href="javascript:" class="btn btn-primary text-white btn-block font-weight-bold btn-bottom d-flex align-items-center justify-content-center" @click="$emit('openSacola')" style="max-width: 500px; height: 53px">
                <div id="sacolaAnimated" class="d-flex justify-content-between align-items-center w-100">
                  <div style="width: 30px">
                    <icon name="sacola" size="24" full="true"/>
                  </div>
                  <div class="font-weight-bold">
                    Ver Sacola
                  </div>
                  <div class="d-flex justify-content-center" style="min-width: 30px">
                    <span class="contador-sacola text-primary">{{qtdSacola}}</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div :class="{'content': !component}">
        <div class="container-fluid">
          <div class="form-search mb-3">
            <span class="input-icon"><i class="fa fa-search"></i></span>
            <input v-model="termoBusca" id="search" type="search" placeholder="Buscar no cardápio"
                   class="form-control ipt-pesquisar">
          </div>
          <div class="row no-gutters">
            <div class="menu-container mb-4" :class="origin === '8' ? 'col-md-3 pr-md-3' : 'col-xl-3 pr-xl-3'" v-show="!searching">
              <div class="menu-categorias" :class="{menuFixed}">
                <categorias-menu ref="menu" :menuFixed="menuFixed" @changeMenu="changeMenu" @pesquisar="focusSearch()" v-if="bdCategorias.length > 0"/>
              </div>
            </div>
            <div :class="searching ? 'col-xl-12' : (origin === '8' ? 'col-md-9' : 'col-xl-9')">
              <div v-if="searching">
                <produtos :produtos="search" @openProduto="openProduto"/>
              </div>
              <div v-show="!searching">
                <div class="mt-md-2 mb-4" v-for="categoria in bdCategorias" :key="categoria.id_categoria">
                  <div :id="`cat${categoria.id_categoria}`" class="mb-3">
                    <h5 class="font-weight-bold mb-0">{{categoria.nome_categoria}}</h5>
                    <p class="mb-0" v-if="categoria.descricao_categoria">{{categoria.descricao_categoria}}</p>
                  </div>
                  <produtos :produtos="categoria.produtos" @openProduto="openProduto"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <produto :categoria="categoria" ref="produto" :empresaAberta="empresaAberta" @modalImage="openModalImg"/>
    <modal-image :opened="modalImage" :url="modalImage ? modalImage : base_cdn + '/static/imgs/default.png'" @closeModal="modalImage = false"/>
  </div>
</template>

<script>
  import TopBar from '../components/TopBar'
  import Loading from '../components/Loading'
  import CategoriasMenu from '../components/CategoriasMenu'
  import Produtos from '../components/ProdutosCategoria'
  import CardInfo from '../components/CardInfo'
  import Produto from '../components/Produto'
  import Icon from "../components/Icon";
  import ModalImage from "../components/ModalImage";
  import CSacola from "../components/CSacola";
  import BottomBar from "../components/BottomBar";

  export default {
    name: 'Categorias',
    components: {BottomBar, CSacola, ModalImage, Icon, TopBar, Loading, CategoriasMenu, Produtos, CardInfo, Produto},
    props: ['component'],
    data() {
      return {
        load: false,
        url: '',
        categoria: null,
        urlParams: '',
        empresaAberta: false,
        destaque: false,
        modalImage: false,
        menuFixed: false,
        animateMenu: false,
        termoBusca: '',
        observer: null,

        ignoreObserver: false,
        ignoreTimeout: null,
        lastScrollY: 0,
        scrollDirection: 'down',

      }
    },

    methods: {
      syncMenuBar(cat, change) {
        if (this.$refs.menu) {
          this.$refs.menu.changeMenuBar(cat, change);
        }
      },

      getProdutos(cat, produto) {
        let categoria = cat ? this.bdCategorias.find(c => c.id_categoria === cat) : null;
        categoria = categoria || this.bdCategorias[0];

        if (!this.component) {
          this.changeMenu(categoria, false, 'auto');

          if (produto) {
            this.openProduto(produto, categoria.id_categoria);
          }

        } else {
          this.categoria = categoria;
        }
      },

      openProduto(id, id_categoria) {
        if (this.component) {
          this.$router.push(`${this.url}/categorias/?id=${id_categoria}&produto=${id}`);

        } else {
          this.$refs.produto.openProduto({ id, id_categoria });
        }
      },

      changeMenu(cat, change, behavior = 'smooth') {
        if (!this.bdCategorias?.length) return;

        this.ignoreObserver = true;
        this.categoria = cat || this.bdCategorias[0];
        const id_categoria = this.categoria?.id_categoria || '';
        let targetTop = 0;

        // Calcula posição alvo
        if (this.bdCategorias[0].id_categoria !== id_categoria) {
          if (this.component) {
            const div = document.getElementById('divProdutos');
            if (div) {
              targetTop = div.offsetTop - (window.innerWidth > 768 ? 80 : 14);
            }

          } else if (id_categoria) {
            const el = document.getElementById(`cat${id_categoria}`);

            if (el) {
              const pageW = window.innerWidth;
              const offset = (this.origin === '8') ? 55 : 155;
              targetTop = el.offsetTop + (pageW < 768 ? 140 : (pageW < 1200 ? offset : 55));
            }
          }
        }

        this.syncMenuBar(this.categoria.id_categoria, !change);
        window.scrollTo({ top: targetTop, behavior });

        // Reativa observer
        clearTimeout(this.ignoreTimeout);
        this.ignoreTimeout = setTimeout(() => {
          this.ignoreObserver = false;
        }, 800);
      },

      openModalImg(img) {
        if (img) {
          this.modalImage = img;
        }
      },

      scroll() {
        const currentScrollY = window.scrollY;
        this.scrollDirection = currentScrollY > this.lastScrollY ? 'down' : 'up';
        this.lastScrollY = currentScrollY;

        if ((currentScrollY > 132) !== this.menuFixed) {
          this.menuFixed = !this.menuFixed;

        } else if (!currentScrollY) {
          this.syncMenuBar(this.bdCategorias[0]?.id_categoria, true);
        }
      },

      focusSearch() {
        const input = document.getElementById('search');
        if (!input) return;
        input.focus();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },

      initEvents() {
        document.addEventListener("scroll", this.scroll);

        this.observer = new IntersectionObserver(this.onIntersect, {
          root: null,
          threshold: [1],
          rootMargin: "-95px 0px 0px 0px"
        });

        this.$nextTick(() => {
          this.bdCategorias.forEach(cat => {
            const el = document.getElementById(`cat${cat.id_categoria}`);
            if (el) this.observer.observe(el);
          });
        });
      },

      onIntersect(entries) {
        if (this.ignoreObserver) return;

        const headerStart = 133;
        const headerHeight = 102;
        const topo = window.scrollY < headerStart ? 0 : headerHeight;

        entries.forEach(entry => {
          const id = entry.target.id.replace("cat", "");
          const rect = entry.target.getBoundingClientRect();
          const elementTop = rect.top - topo;

          // Descendo - ativa quando o topo do elemento passa pelo topo da viewport
          if (this.scrollDirection === 'down') {
            if (elementTop <= 0 && !entry.isIntersecting) {
              this.syncMenuBar(id, true);
            }

          } else {
            // Subindo - ativa quando o elemento começa a aparecer
            if (entry.isIntersecting && elementTop >= -50) {
              this.syncMenuBar(id, true);
            }
          }
        });
      }
    },

    mounted() {
      this.empresaAberta = this.empresa.empresaAberta;

      this.$nextTick(() => {
        this.urlParams = new URLSearchParams(window.location.search);
        this.destaque = this.urlParams.get('destaque');

        if (this.urlParams.get('search')) {
          this.focusSearch();
        }

        this.getProdutos(this.urlParams.get('id'), this.urlParams.get('produto'));
      });

      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');

      // eventos
      this.initEvents();
    },

    created() {
      document.body.classList.remove("modal-open");
    },

    beforeDestroy() {
      document.removeEventListener('scroll', this.scroll);

      if (this.observer) {
        this.observer.disconnect();
      }
    },

    beforeRouteLeave(to, from, next) {
      if (['Cadastro','Login','Finalizar'].includes(to.meta.page)) {
        next();
        return;
      }

      if (this.$refs.bottomBar && this.$refs.bottomBar.openSacola) {
        this.$refs.bottomBar.openSacola = false;
        next(false);

      } else if (this.modalImage) {
        this.modalImage = false;
        next(false);

      } else if (this.$refs.produto && this.$refs.produto.aberto && !this.destaque) {
        this.$refs.produto.closeProduto();
        next(false);

      } else {
        next()
      }
    },

    computed: {
      searching() {
        return !!this.termoBusca.trim();
      },

      search() {
        const termos = this.$helpers.normalizeString(this.termoBusca)
          .split(' ')
          .filter(Boolean);

        if (!termos.length) {
          return [];
        }

        return this.produtos.filter(produto =>
          termos.every(termo => produto.texto_busca.includes(termo))
        );
      },

      empresa() {
        return this.$store.state.empresa
      },

      bdCategorias() {
        return this.$store.state.cardapio.categorias
      },

      produtos() {
        return this.$store.state.cardapio.produtos || [];
      },

      qtdSacola() {
        const qtd = this.$store.state.sacola.produtos.length;
        return qtd < 10 ? qtd : 9;
      }
    }
  }
</script>
<style>
  .contador-sacola {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    padding: 0 6px;
    border-radius: 12px;
    background-color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
  }

  @media (max-width: 767px) {
    .menu-container {
      min-height: 83px;
    }

    .menu-categorias.menuFixed {
      top: 0;
      left: 0;
      right: 0;
      z-index: 1;
      position: fixed;
      background-color: #F4F5F7;
      padding: 10px 15px 0;
      border-bottom: 1px solid #E9ECEF;
    }
  }

  @media (min-width: 769px) {
    .menu-categorias {
      top: 82px;
      position: sticky;
    }
  }
</style>
